module.exports = __webpack_public_path__ + "img/1559294495.1c6bcd27.jpg";